import { getCustomerProfile } from '../services/backendClient'

export const CUSTOMER_PROFILE = 'CUSTOMER_PROFILE'

export const getProfile = () => ({
  type: CUSTOMER_PROFILE,
  promise: getCustomerProfile()
})
